<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Senarai : pelanggan ">
            <w-form>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <z-lookup
                            label="Kategori Profil"
                            :options="kategori"
                            v-model="cari.kategori"
                            :url="
                                service_kutipan + 'lookup/profil_Kategori'
                            "
                            placeholder="Sila Pilih Kategori Profil"
                            :sort="false"
                            :cache="false"
                        />
                    </div>

                    <div class="xs6 mr3">
                        <w-input
                            placeholder="Sila Masukan ID/Nama"
                            v-model="cari.nama_id"
                            >No. ID ( No Kad Pengenalan / No Tentera / No Daftar
                            Syarikat ) / Nama
                        </w-input>
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt3 mb3" wrap align-center justify-end>
                <div class="text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="search()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <z-table
                ref="tbluser"
                title="Senarai : Pelanggan"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                <!-- <template #button>
                   <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                   </w-button>
            </template> -->

                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <inertia-link
                            :href="$route('kutipan.pelanggan.show', item.id)"
                        >
                            <w-tooltip top>
                                <template #activator="{ on }">
                                    <w-icon v-on="on"> fal fa-pencil </w-icon>
                                </template>
                                Kemaskini
                            </w-tooltip>
                        </inertia-link>
                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
// import ZenOne from '@/Shared/ZenOne'
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_kutipan + "profil",
            reload: true,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Pelanggan", route: "/kutipan/pelanggan" },
                { label: "Senarai", route: "/kutipan/pelanggan" },
            ],

            kategori: [
                {
                    value: 1,
                    label: "INDIVIDU",
                },
                {
                    value: 2,
                    label: "SYARIKAT",
                },
            ],

            cari: { kategori: "", nama: "", no_id: "", nama_id: "" },
        };
    },
    methods: {
        search() {
            // var url = window.route('kutipan.pelanggan.index')+'?kategori='+this.cari.kategori+'&nama='+this.cari.nama;
            // var url = window.route('kutipan.pelanggan.index')+'?kategori='+this.cari.kategori+'&no_id='+this.cari.no_id;
            var url =
                window.route("kutipan.pelanggan.index") +
                "?kategori=" +
                this.cari.kategori +
                "&nama_id=" +
                this.cari.nama_id;
            // var url = window.route('kutipan.pelanggan.index')+'?kategori='+this.cari.kategori+'&nama='+this.cari.nama+'&no_id='+this.cari.no_id+'&nama_id='+this.cari.nama_id;
            this.$inertia.visit(url, { preserveScroll: true });
        },

        reset() {
            this.cari = { kategori: "", nama: "", no_id: "", nama_id: "" };
            this.search();
        },

        // cetak() {
        //     window.location.href = this.service_kutipan+'pelanggan/cetak/'+this.id;
        // },
    },
    watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 500;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.kategori == "undefined") {
            this.cari.kategori = "";
        }
        if (this.cari.nama == "undefined") {
            this.cari.nama = "";
        }
        if (this.cari.no_id == "undefined") {
            this.cari.no_id = "";
        }
        if (this.cari.nama_id == "undefined") {
            this.cari.nama_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
